import { CovenantTypeTag, REGIONS, EventDrivenTag } from '../../../models';

export interface QuickFilter {
  title: string;
  filterTags: Record<string, string>;
}
export const QUICK_FILTERS: QuickFilter[] = [
  {
    title: 'North American Bond Research',
    filterTags: { region: REGIONS.NorthAmerica, covenants_source: CovenantTypeTag.BondTransaction },
  },
  {
    title: 'North American Loan Research',
    filterTags: { region: REGIONS.NorthAmerica, covenants_source: CovenantTypeTag.LoanTransaction },
  },
  {
    title: 'Topical Research',
    filterTags: { covenants_source: EventDrivenTag.TopicalResearch },
  },
  {
    title: 'Covenant Primers',
    filterTags: { covenants_source: EventDrivenTag.CovenantPrimers },
  },
  {
    title: 'Plain English Glossary',
    filterTags: { covenants_source: EventDrivenTag.PlainEnglishGlossary },
  },
  {
    title: 'European Bond Research',
    filterTags: { region: REGIONS.Europe, covenants_source: CovenantTypeTag.BondTransaction },
  },
  {
    title: 'European Loan Research',
    filterTags: { region: REGIONS.Europe, covenants_source: CovenantTypeTag.LoanTransaction },
  },
  {
    title: 'Trendlines Research',
    filterTags: { covenants_source: EventDrivenTag.TrendlinesResearch },
  },
  {
    title: 'Loans vs. Bonds',
    filterTags: { covenants_source: EventDrivenTag.LoansBonds },
  },
];
